import { ACTIVITY_ID } from '@src/constants/urls';
export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获得初始化配置
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/get_init

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "cdk_open_status": 2,
	        "activity_status": 1,
	        "login_mission_status": 2,
	        "H5_games_status": 4,
	        "pv_url": "https://static-www.cbjq.com/cht3.0pv.mp4",
	        "ankaxiya_pv_url": "https://static-www.cbjq.com/video/20250724/rolepv/chenbai30kuagnshi_cn.mp4",
	        "molian_pv_url": "https://static-www.cbjq.com/video/20250724/rolepv/chenbai30taisiqihuan_cn.mp4",
	        "activity_img_url": [
	            "https://www.cbjq.com/p/zt/2025/07/10/fab/img/p5_pic1.299f9084.jpg",
	            "https://www.cbjq.com/p/zt/2025/07/10/fab/img/p5_pic2.9d84b9cc.jpg",
	            "https://www.cbjq.com/p/zt/2025/07/10/fab/img/p5_pic3.e3ce77e5.jpg",
	            "https://www.cbjq.com/p/zt/2025/07/10/fab/img/p5_pic4.a75bd79f.jpg",
	            "https://www.cbjq.com/p/zt/2025/07/10/fab/img/p5_pic5.14134194.jpg"
	        ],
	        "session_id": "hQC8UclcWarGoIe11mSK2kiUFjCrzVjU7CaefqmE",
	        "request_id": "8f869e8027411e8dfb2430d5acc09ce75e7c177e"
	    }
	 }
		*/
  service.getInit = function() {
    return request.jsonp(rootAddress + '/cbjq/fab251212/get_init', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "H5_games_status": "H5游戏状态（0：未开始，1：第一阶段，2：第一阶段结束第二阶段未开启，3：第二阶段开启，4：第二阶段结束第三阶段未开启，5：第三阶段开启，6：第三阶段结束）",
            "activity_img_url": "活动特色（五图）",
            "activity_status": "抽奖活动状态（0：未开始，1：进行中，2：已结束）",
            "ankaxiya_pv_url": "安卡希雅pv链接",
            "cdk_open_status": "cdk按钮开启时间（0：未开启，1：开启，2：已结束）",
            "login_mission_status": "登录任务开启状态（0：未开启，1：开启，2：已结束）",
            "molian_pv_url": "茉莉安pv链接",
            "pv_url": "pv首页地址"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		游戏免登和获得登录态
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/get_login_status?params=CPQgWw%2BNyK6vAwzV5fHZBXS53sIaSGo4GHVgxg4BclWE7X4Wfd31XMRXfP9gckToKSorDm%2BjFHKN%2FyHRF77BlCtFUduTgmywHtPi5jA5GF79r3KVdTB9B9NSibQlVUaPYGdjyjBhMglz%2FB2jj6knqiJVyMyF%2BvTNN7V4PKH4Iw0%3D&sync_passport=true

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "nickname": "j**********k",
	        "session_id": "uN7O13pY1gzvCWHiExubjUBRIL7ts83mZI3cTShO",
	        "request_id": "fc39d728bc097828f3618da8d80a54c37e81089a"
	    }
	 }
		*/
  service.getLoginStatus = function(params) {
    return request.jsonp(rootAddress + '/cbjq/fab251212/get_login_status', {
      params: params /*  免登参数 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "nickname": "登录后展示昵称"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20118",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20123",
        "description": "获取uid失败"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		初始化账号信息
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/get_config?params=llxW8vrf5Bha+UpwLXWF/1Cm70BV6QqV5Ht2F0FUrpbn6WbaKcIFWspweC7J+A3njZeJuKViFvEo4wHZYd1mFV/q5MiKYdg2TqgmjXqmFmFmirGRKcpfxf4qfZRw6k4h8Sp9UzMLcT/3E4iurUCCj22lcM8yj5WkH3QpO/YFs1cvWDWBgvnO08JLrx51PK5W4PbPkKFS20ZvBaoDJ3qpKfw+2aug2ZyZxzlwAPplW5H4T5X6rOk0IqI+aUoTEkwm

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "account": "j**********k",
	        "lottery_time": 1,
	        "game_login_time": 1,
	        "view_status": 0,
	        "subscribe_bili_status": 0,
	        "subscribe_weibo_status": 0,
	        "share_h5": 0,
	        "daily_share_status": 0,
	        "daily_share_time": 0,
	        "today_login_mission": 1,
	        "lottery_inc_time": 1,
	        "utm_source": "",
	        "is_get_entity_prize": 0,
	        "session_id": "uN7O13pY1gzvCWHiExubjUBRIL7ts83mZI3cTShO",
	        "request_id": "cc6010c4845a1a515dabb16b2ec4e4c4aa00b38d"
	    }
	 }
		*/
  service.getConfig = function(params) {
    return request.jsonp(rootAddress + '/cbjq/fab251212/get_config', {
      params: params /*  免登参数 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "account": "通行证账号/渠道服游戏uid",
            "daily_share_status": "每日分享任务是否完成（1：是，0：否）",
            "daily_share_time": "分享任务完成总次数",
            "game_login_time": "活动期间登录游戏天数",
            "is_get_entity_prize": "是否获得实物奖励（1：是，0：否）",
            "lottery_inc_time": "增加的抽奖次数（只在登录任务增加次数时返回的值大于0，其他情况值均为0）",
            "lottery_time": "抽奖次数",
            "share_h5": "分享h5活动:0=未完成,1=完成",
            "subscribe_bili_status": "是否完成关注B站（1：是，0：否）",
            "subscribe_weibo_status": "是否完成关注微博（1：是，0：否）",
            "today_login_mission": "是否完成当天游戏登录（1：已完成，0：未完成）",
            "utm_source": "游戏内免登携带的utm_source（不一定有值）",
            "view_status": "是否完成观看pv任务（1：是，0：否）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20118",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20120",
        "description": "数据加载中"
      }, {
        "code": "-20123",
        "description": "获取uid失败"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		完成任务
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/mission_done?m_type=1

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "inc_lottery_time": 1,
	        "session_id": "sbYQot1K46Wdee0TApsuOeXHzm41VThpGrlfcgd6",
	        "request_id": "42d86ce8074bc08f4ef1fc358a28fbfc8497f736"
	    }
	 }
		*/
  service.missionDone = function(m_type) {
    return request.jsonp(rootAddress + '/cbjq/fab251212/mission_done', {
      m_type: m_type /*  任务类型（1：查看PV，2：分享第一天，3：分享第二天，4：分享第三天，5：前往H5，6：订阅B站，7：订阅微博） */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "inc_lottery_time": "增加抽奖次数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20103",
        "description": "任务类型不匹配"
      }, {
        "code": "-20104",
        "description": "每日分享获得抽奖次数已达上限"
      }, {
        "code": "-20105",
        "description": "任务已完成"
      }, {
        "code": "-20118",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20121",
        "description": "每日分享任务完成次数不匹配"
      }, {
        "code": "-20123",
        "description": "获取uid失败"
      }, {
        "code": "-20125",
        "description": "敬请期待"
      }, {
        "code": "-20126",
        "description": "敬请期待"
      }, {
        "code": "-20127",
        "description": "H5活动第二阶段未开启"
      }, {
        "code": "-20128",
        "description": "H5活动第三阶段未开启"
      }, {
        "code": "-20129",
        "description": "H5活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽取奖励
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/lottery

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "prize_id": 4,
	        "prize_type": 2,
	        "session_id": "sbYQot1K46Wdee0TApsuOeXHzm41VThpGrlfcgd6",
	        "request_id": "6cd917d4e48a217db7046f9e71598e211c79986f"
	    }
	 }
		*/
  service.lottery = function() {
    return request.jsonp(rootAddress + '/cbjq/fab251212/lottery', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "prize_id": "奖励id",
            "prize_type": "奖励类型（1：实物，2：虚拟，3：保底奖励）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20111",
        "description": "抽奖次数不足"
      }, {
        "code": "-20112",
        "description": "请先完善配置"
      }, {
        "code": "-20118",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20119",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20123",
        "description": "获取uid失败"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖记录
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/lottery_log

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "log": [
	            {
	                "prize_type": "1",
	                "prize_id": "6",
	                "create_time": 1753414930
	            }
	        ],
	        "address": {
	            "receiver": "阿西西",
	            "phone": "15913351517",
	            "address": "广东珠海金山软件园"
	        },
	        "is_get_entity_prize": 1,
	        "session_id": "xIWVWL42d3REco9BykIUBRbGFnVqyr3CecsFsUQq",
	        "request_id": "5493ef6b6c137377ae0c8df690c7683ff1376460"
	    }
	 }
		*/
  service.lotteryLog = function() {
    return request.jsonp(rootAddress + '/cbjq/fab251212/lottery_log', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "address": "领奖地址信息",
            "is_get_entity_prize": "是否获得实物",
            "log": "奖励记录"
          },
          "data{}.address{}": {
            "address": "领奖地址信息",
            "phone": "手机号",
            "receiver": "收件人"
          },
          "data{}.log[]": {
            "create_time": "创建时间",
            "prize_id": "奖励id",
            "prize_type": "奖励类型（1：实物，2：虚拟，3：保底奖励）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20118",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20123",
        "description": "获取uid失败"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		收件地址
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/set_address?receiver=阿西西&phone=15913351517&address=广东珠海金山软件园

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "xIWVWL42d3REco9BykIUBRbGFnVqyr3CecsFsUQq",
	        "request_id": "45dbebad0eadaee7dca86b99ade851c8920f9c9c"
	    }
	 }
		*/
  service.setAddress = function(receiver, phone, address) {
    return request.jsonp(rootAddress + '/cbjq/fab251212/set_address', {
      receiver: receiver /*  收件人 */ ,
      phone: phone /*  手机号 */ ,
      address: address /*  领奖地址信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10402",
        "description": "请先登录"
      }, {
        "code": "-10435",
        "description": "不支持的通行证登录方式"
      }, {
        "code": "-20106",
        "description": "收件地址已填写"
      }, {
        "code": "-20107",
        "description": "未获得实物奖励，无法填写收件地址"
      }, {
        "code": "-20108",
        "description": "请填写完整的收件信息"
      }, {
        "code": "-20109",
        "description": "收件人名称涉及敏感词汇，请修改"
      }, {
        "code": "-20118",
        "description": "网络繁忙，请稍后重试！"
      }, {
        "code": "-20123",
        "description": "获取uid失败"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		退出登录（游戏免登和通行证登录均会退出）
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/logout

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "xIWVWL42d3REco9BykIUBRbGFnVqyr3CecsFsUQq",
	        "request_id": "b48ef3a0d571943a509818525840334bbf091dbf"
	    }
	 }
		*/
  service.logout = function() {
    return request.jsonp(rootAddress + '/cbjq/fab251212/logout', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得游戏免登参数
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/game_login_param?account=jinshan_a123456&nick=jinshan_nick&url_encrypt=1

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "param": "vB9FIRtBERpI8sSdxPSvVuXkARJZ0lKNt1CJm%2BwtExrGRuTbh%2BHqXzhQjUZ9OkzBBLxqdABTaQIacPTvuP55mUWE3KznlXaYdzKdGLOnqB7WJWjzFtjkXUW%2BJ09GfjnVFyG%2ByFCAhH6arNt177K1VhbRsvdI%2FJspt08QDBEnpeg%3D",
	        "session_id": "iXZLtUyHZhJACOIwzkM5hUooOzbTJtxYmi2NZ9gL",
	        "request_id": "fc76162eb6609f7b0bfd09c6285c957ee0454e05"
	    }
	 }
		*/
  service.gameLoginParam = function(account, nick, url_encrypt) {
    return request.jsonp(rootAddress + '/cbjq/fab251212/game_login_param', {
      account: account /*  通行证游戏uid */ ,
      nick: nick /*  角色昵称 */ ,
      url_encrypt: url_encrypt /*  是否urlencode（1：是，0：否） */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "param": "免登参数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
        return reject(response);
      });
  };
  service.getActivityConfig = function() {
    return request
      .jsonp(rootAddress + '/cbjq/sendcode/get_config', {
        activity_id: ACTIVITY_ID
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }
        return reject(response);
      });
  };

  service.getPhoneCode = function(params) {
    return request.jsonp(rootAddress + '/cbjq/sendcode/get_phone_code', { ...params, activity_id: ACTIVITY_ID }).then(response => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };

  service.getCdkCode = function(params) {
    return request.jsonp(rootAddress + '/cbjq/sendcode/get_cdk_code', { ...params, activity_id: ACTIVITY_ID }).then(response => {
      if (response.status === 1 /* 成功 */) {
        return response.data;
      }
      return reject(response);
    });
  };
  /**
		登录类型
		请求方法: GET, POST
		请求示例: http://<domain>/cbjq/fab251212/get_login_type

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "type": 0,
	        "uid": "d41d8cd98f00b204e9800998ecf8427e",
	        "session_id": "oImZmhmx4qSXWaxDD3xKpPENKkn0EdB0gDN2Cgp4",
	        "request_id": "77e9d07c9aa5c0e508c6da3358b3b574ed071947"
	    }
	 }
		*/
  service.getLoginType = function() {
    return request.jsonp(rootAddress + '/cbjq/fab251212/get_login_type', {}).then(response => {
      if (response.status === 1 /* 成功 */) {
        /**
          {
            "data{}": {
              "type": "登录类型（0：通行证登录，1：游戏免登）",
              "uid": "uid"
            }
          }
              */
        return response.data;
      }
      /**
        [{
          "code": "0",
          "description": "系统错误"
        }, {
          "code": "-10151",
          "description": "活动未开启"
        }, {
          "code": "-10152",
          "description": "活动配置错误"
        }, {
          "code": "-10153",
          "description": "活动未开始"
        }, {
          "code": "-10154",
          "description": "活动已结束"
        }, {
          "code": "-10402",
          "description": "请先登录"
        }, {
          "code": "-10435",
          "description": "不支持的通行证登录方式"
        }, {
          "code": "-20118",
          "description": "网络繁忙，请稍后重试！"
        }, {
          "code": "-20123",
          "description": "获取uid失败"
        }]
            */
      return reject(response);
    });
  };

  return service;
}
